import { Button } from './button';
import './ui.css';

export function Dialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  closeLabel = 'Close',
}) {
  if (!open) {
    return null;
  }

  return (
    <div className="ui-dialog-overlay" onClick={() => onOpenChange(false)}>
      <div className="ui-dialog-content" onClick={(event) => event.stopPropagation()}>
        <div className="ui-dialog-header">
          <h3 className="ui-card-title">{title}</h3>
          {description ? <p className="ui-card-description">{description}</p> : null}
        </div>
        <div className="ui-dialog-body">{children}</div>
        <div className="ui-card-footer">
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            {closeLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
